export const SONARIS_SESSION_KEY = "sonaris.session"
